import { SvgIcon } from "@mui/material";
import { CSSProperties } from "react";

const SubmitIcon = ({ scale, color, style }: { scale?: number; color?: string; style?: CSSProperties }) => {
  let c = "#1E8E1B";
  if (color) c = color;
  return (
    <SvgIcon
      style={{ transform: `scale(${scale || 1})`, fill: "none" }}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        clip-rule="evenodd"
        d="M14.737 2.762H8.085A3.819 3.819 0 0 0 4.25 6.49v10.85a3.714 3.714 0 0 0 3.65 3.777c.06 0 .123 0 .185-.002h7.988a3.769 3.769 0 0 0 3.73-3.775v-9.3l-5.066-5.278Z"
        stroke={c}
        strokeWidth="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M14.473 2.75v2.91a2.575 2.575 0 0 0 2.57 2.574h2.753m-11.485 5.85 2.477 2.504 4.953-5.008"
        stroke={c}
        strokeWidth="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </SvgIcon>
  );
};

export default SubmitIcon;
